import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
`;

export default GlobalStyles;
